export const en = {
  shared: {
    brand: "OrderHub",
    linkHint: "If the button above doesn't work, copy and paste this link into your browser:",
  },
  resetPassword: {
    subject: "Reset your password — OrderHub",
    brand: "OrderHub",
    greeting: "Hi {{name}},",
    body: "We received a request to reset the password for your OrderHub account. Click the button below to choose a new password.",
    cta: "Reset Password",
    linkHint: "If the button above doesn't work, copy and paste this link into your browser:",
    footer: "This link expires in 1 hour. If you didn't request a password reset, you can safely ignore this email — your password will remain unchanged.",
  },
  verification: {
    subject: "Verify your email address — OrderHub",
    heading: "Please verify your email address",
    body: "Thanks for signing up for OrderHub! Please verify your email address to unlock full functionality, including connecting Shopify stores and creating trigger rules.",
    cta: "Verify Email Address",
    footer: {
      withToken: "This link expires in 24 hours. If you didn't create an account with OrderHub, you can safely ignore this email.",
      noToken: "If you didn't create an account with OrderHub, you can safely ignore this email.",
    },
  },
  reactivation: {
    subject: "You've been re-added to {{orgName}} on OrderHub",
    heading: "Welcome back!",
    body: "{{inviterName}} has re-added you to {{orgName}} on OrderHub. Your account has been reactivated. You can log in using your existing credentials.",
    cta: "Log in to OrderHub",
    footer: "If you weren't expecting this, you can safely ignore this email.",
  },
  invitation: {
    subject: "{{inviterName}} invited you to join {{orgName}} on OrderHub",
    heading: "You're invited!",
    body: {
      p1: "{{inviterName}} has invited you to join {{orgName}} on OrderHub.",
      p2: "OrderHub helps teams manage Shopify orders, draft orders, and abandoned checkouts with a structured follow-up workflow.",
    },
    cta: "Accept Invitation",
    footer: "If you weren't expecting this invitation, you can safely ignore this email.",
  },
};